export default __webpack_public_path__ + "static/logo-f0ae5deb50233f0e21277d8d233de017.png";